module.exports = __webpack_public_path__ + "img/science_app_3.95b5df13.jpg";